// extracted by mini-css-extract-plugin
module.exports = {"bot":"Bot_bot__-ghxP"};